import { BACKGROUND_TASK_STATES, BACKGROUND_TASK_STATUS_TYPE, CAD_TASK_TYPES, POINT_CLOUD_TASK_TYPES, VIDEO_MODE_TASK_TYPES, WS_MIGRATION_TASK_TYPES } from "@api/progress-api/progress-api-constants";
/**
 * @returns true if the object type is ProgressApiLatestStatusResponse
 */
export function isProgressApiLatestStatusResponse(response) {
  if (!response || typeof response !== "object") {
    return false;
  }
  const toCheck = response;
  return !!toCheck.data && toCheck.data.every(isBackgroundTask) && typeof toCheck.totalCount === "number" && typeof toCheck.pageSize === "number" && (typeof toCheck.before === "string" || toCheck.before === null) && (typeof toCheck.after === "string" || toCheck.after === null);
}

/**
 * @returns true if the object type is BackgroundTask
 */
export function isBackgroundTask(data) {
  if (!data || typeof data !== "object") {
    return false;
  }
  const toCheck = data;
  return typeof toCheck.id === "string" && typeof toCheck.createdAt === "string" && (isBackgroundTaskType(toCheck.taskType) || toCheck.taskType === null) && (isBackgroundTaskContext(toCheck.context) || toCheck.context === null) && (isBackgroundTaskStatus(toCheck.status) || toCheck.status === null) && (toCheck.tags && toCheck.tags.every(tag => typeof tag === "string") || toCheck.tags === null);
}

/**
 * @returns true if the object type is BackgroundTaskType
 */
export function isBackgroundTaskType(taskType) {
  if (!taskType || typeof taskType !== "string") {
    return false;
  }
  return true;
}

/**
 * @returns true if the object type is PointCloudTaskType
 */
export function isPointCloudTaskType(taskType) {
  if (!taskType || typeof taskType !== "string") {
    return false;
  }
  return Object.values(POINT_CLOUD_TASK_TYPES).includes(taskType);
}

/**
 * @returns true if the object type is VideoModeTaskType
 */
export function isVideoModeTaskType(taskType) {
  if (!taskType || typeof taskType !== "string") {
    return false;
  }
  return Object.values(VIDEO_MODE_TASK_TYPES).includes(taskType);
}

/**
 * @returns true if the object type is CadTaskType
 */
export function isCadTaskType(taskType) {
  if (!taskType || typeof taskType !== "string") {
    return false;
  }
  return Object.values(CAD_TASK_TYPES).includes(taskType);
}

/**
 * @returns true if the object type is WSMigrationTaskType
 */
export function isWSMigrationTaskType(taskType) {
  if (!taskType || typeof taskType !== "string") {
    return false;
  }
  return Object.values(WS_MIGRATION_TASK_TYPES).includes(taskType);
}

/**
 * @returns true if the object type is BackgroundTaskContext
 */
export function isBackgroundTaskContext(context) {
  if (!context || typeof context !== "object") {
    return false;
  }
  const toCheck = context;
  return (typeof toCheck.companyId === "string" || toCheck.companyId === null) && (typeof toCheck.projectId === "string" || toCheck.projectId === null) && (typeof toCheck.userId === "string" || toCheck.userId === null) && (typeof toCheck.correlationId === "string" || toCheck.correlationId === null) && typeof toCheck.jobId === "string" && (typeof toCheck.elementId === "string" || toCheck.elementId === null);
}

/**
 * @returns true if the object type is BackgroundTaskStatus
 */
export function isBackgroundTaskStatus(status) {
  return isBackgroundTaskStateUpdate(status) || isBackgroundTaskProgressUpdate(status);
}
function isBackgroundTaskStatusBase(status) {
  if (!status || typeof status !== "object") {
    return false;
  }
  const toCheck = status;
  return typeof toCheck.id === "string" && Object.values(BACKGROUND_TASK_STATUS_TYPE).includes(toCheck.type) && typeof toCheck.changedAt === "string" && (typeof toCheck.devMessage === "string" || toCheck.devMessage === null) && (typeof toCheck.errorCode === "string" || toCheck.errorCode === null) && "result" in toCheck;
}

/**
 * @returns true if the object type is BackgroundTaskStateUpdate
 */
export function isBackgroundTaskStateUpdate(status) {
  if (!status || typeof status !== "object") {
    return false;
  }
  const toCheck = status;
  return isBackgroundTaskStatusBase(status) && status.type === BACKGROUND_TASK_STATUS_TYPE.State && isBackgroundTaskStates(toCheck.state);
}

/**
 * @returns true if the object type is BackgroundTaskProgressUpdate
 */
export function isBackgroundTaskProgressUpdate(status) {
  if (!status || typeof status !== "object") {
    return false;
  }
  const toCheck = status;
  return isBackgroundTaskStatusBase(status) && status.type === BACKGROUND_TASK_STATUS_TYPE.Progress && isBackgroundTaskStatusProgress(toCheck.progress);
}

/**
 * @returns true if the object type is BackgroundTaskStates
 */
function isBackgroundTaskStates(state) {
  if (!state || typeof state !== "string") {
    return false;
  }
  return Object.values(BACKGROUND_TASK_STATES).includes(state);
}

/**
 * @returns true if the object type is BackgroundTaskStatusProgress
 */
function isBackgroundTaskStatusProgress(progress) {
  if (!progress || typeof progress !== "object") {
    return false;
  }
  const toCheck = progress;
  return typeof toCheck.current === "number" && typeof toCheck.total === "number";
}